var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue, } from "vue-property-decorator";
import InfoIcon from "../../components/articleattributes/infoicon.vue";
let EditDataElementLabel = class EditDataElementLabel extends Vue {
    onClicked() { this.networkBroker.showInfo(this.elementKey); }
};
__decorate([
    Prop({ required: true })
], EditDataElementLabel.prototype, "elementKey", void 0);
__decorate([
    Prop({ required: true })
], EditDataElementLabel.prototype, "showInfoIcon", void 0);
__decorate([
    Prop({ required: true })
], EditDataElementLabel.prototype, "suffix", void 0);
__decorate([
    Inject()
], EditDataElementLabel.prototype, "i18n", void 0);
__decorate([
    Inject()
], EditDataElementLabel.prototype, "networkBroker", void 0);
EditDataElementLabel = __decorate([
    Component({
        components: {
            InfoIcon,
        },
        name: "EditDataElementLabel",
    })
], EditDataElementLabel);
export default EditDataElementLabel;
